// Import dependencies
import { unsafeCSS, css, html, LitElement } from 'lit';
import { customElement, property } from 'lit/decorators.js';
const { isEmpty } = _uo.utility;

// Import style for web component
import styles from './web-component-style.scss';

// Translatable strings
const strings = UncannyAutomator._core.i18n.components.item;

// eslint-disable-next-line require-jsdoc
@customElement( 'uap-builder-item-menu-button-support' )
export class AutomatorBuilderItemMenuButtonSupport extends LitElement {
	// Define style
	static styles = css`${ unsafeCSS( styles ) }`;

	// Properties
	@property( { type: String, attribute: 'support-url' } ) accessor supportURL;

	// eslint-disable-next-line require-jsdoc
	render() {
		// Check if the URL exists at all
		if ( isEmpty( this.supportURL ) ) {
			return;
		}

		return html`
			<uo-button
				color="transparent"
				href=${ this.supportURL }
				target="_blank"
			>
				${ strings.support } <uo-icon id="external-link"></uo-icon>
			</uo-button>
		`;
	}
}
